import { render, staticRenderFns } from "./BoardItemCard.vue?vue&type=template&id=9877a3f0&scoped=true&"
import script from "./BoardItemCard.vue?vue&type=script&lang=js&"
export * from "./BoardItemCard.vue?vue&type=script&lang=js&"
import style0 from "./BoardItemCard.vue?vue&type=style&index=0&id=9877a3f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9877a3f0",
  null
  
)

export default component.exports